// extracted by mini-css-extract-plugin
module.exports = {"container":"_a95bd9e"};